import { BASE_API_URL } from "@/common/urls";

import axios from "axios";
import { removeElementFromArray } from "./utils.array";

export default class FileUploader {
  constructor(vue, card) {
    this.vue = vue;
    this.card = card;
  }

  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  fixName(file) {
    if (!file || file.name) return;

    if (!file.type) {
      return;
    }

    const imagePattern = /image\/(.+)/;
    const imageMatch = file.type.match(imagePattern);
    if (!imageMatch) {
      //console.log("bad file type. skip it", file);
      return;
    }

    file.name = "image." + imageMatch[1];
  }

  canUpload(file) {
    return file && file.name && file.type;
  }

  addToUploadFiles(file) {
    if (!this.canUpload(file) || file.uploadId) return;

    console.trace("file!");
    const uploadId = this.uuidv4();
    file.uploadId = uploadId;
    this.card.uploadingFiles.push({
      uploadId: uploadId,
      name: file.name
    });
  }

  removeFromUploadFiles(file) {
    if (!file || file.uploadId) return;

    removeElementFromArray(
      this.card.uploadFiles,
      this.card.uploadFiles.find(f => f.uploadId == file.uploadId)
    );
  }

  upload(file, buffer) {
    if (!this.canUpload(file)) return;

    this.addToUploadFiles(file);

    var fd = new FormData();
    fd.append("fileName", file.name);
    fd.append("file", file);
    fd.append("uploadId", file.uploadId);
    fd.append("cardId", this.card.id);
    fd.append("boardId", this.card.board_id);
    fd.append("userId", this.vue.$store.state.users.active.id);

    axios({
      method: "post",
      url: `${BASE_API_URL}/upload`,
      data: fd,
      config: {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    })
      .then(response => {})
      .catch(err => {
        this.removeFromUploadFiles(file);
      });
  }

  uploadFiles(files) {
    if (!files || !files.length) return;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      this.uploadFile(file);
    }
  }

  uploadFile(file) {
    if (!file) return;

    this.fixName(file);
    this.addToUploadFiles(file);
    //chrome names all files 'image.png' so if it's really image - let's upload in other situation just skip it
    if (file.name == "image.png") {
      //we must ensure that it's real image
      const image = new Image();
      const _this = this;
      image.onload = function() {
        if (this.width) {
          console.log("its image! width = " + this.width);
          _this._uploadFile(file);
        } else {
          this._removeFromUploadFiles(file);
          console.log("its NOT image!");
        }
      };

      image.src = URL.createObjectURL(file);
      return;
    }

    this._uploadFile(file);
  }

  /* Be careful! it's private method that doesn't check arguments */
  _uploadFile(file) {
    this.addToUploadFiles(file);

    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function() {
        this.upload(file, reader.result);
      }.bind(this),
      false
    );
    reader.readAsDataURL(file);
  }
}
